import { render, staticRenderFns } from "./mode11.vue?vue&type=template&id=422b58ab&scoped=true"
import script from "./mode11.vue?vue&type=script&lang=js"
export * from "./mode11.vue?vue&type=script&lang=js"
import style0 from "./mode11.vue?vue&type=style&index=0&id=422b58ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422b58ab",
  null
  
)

export default component.exports